<template lang="pug">
.re-registration(:class="getComponentClasses()")
  .re-registration-box

    .re-container-form(v-if="showForm")
      .re-form-head
        h2.box-form-title(v-if="showTitle") {{ title }}
        p.box-form-head-message(v-if="showNotice" v-html="notice")

        .re-login-plug
            .login-container {{ $$t('login.label') }} 
                router-link(:to="{ name: $$s('login.route') }") {{ $$t('login.link') }}

        p.box-form-head-error(v-show="!!formErrorMessage" v-html="formErrorMessage")

        p.box-form-head-error(v-show="!fields.gdpr_cookie") You must accept cookies policy to register an account. 
          a(href="" @click.prevent="acceptCookies") Accept

      .re-form-body
        .registration-inputs-box
          .re-inp-box
              re-input(
                v-model.trim="$v.fields.username.$model"
                v-bind="getFieldProps('username', {type: 'text', defaults: {label: 'Username'}})"
              )
          .re-inp-box
              re-input(
                v-model.trim="$v.fields.name.$model" 
                v-bind="getFieldProps('name', {type: 'text', defaults: {label: 'Display Name'}})"
              )
          .re-inp-box.re-inp-box--with-icon
            re-input(
              v-model.trim="$v.fields.email.$model"
              v-bind="getFieldProps('email', {type: 'email', defaults: {label: 'Email'}})"
            )
            .re-inp-box__icon
              img(src="/images/client/got-me-hookd/input-icon-envelope.svg")
          .re-inp-box.re-inp-box--with-icon
            re-input(
              v-model="$v.fields.password.$model"
              v-bind="getFieldProps('password', {type: 'password'})"
              :type="showPassword ? 'text' : 'password'"
            )
            re-input-eye-icon(v-model="showPassword")
          .re-inp-box
            re-checkbox(
              v-model.trim="$v.fields.terms.$model"
              v-bind="getFieldProps('terms')"
            )
              span {{ $$t('form.fields.terms.urls.general') }}
              a.terms-link(:href="$$s('form.fields.terms.urls.terms.url')" target="_blank") {{ $$t('form.fields.terms.urls.terms') }}
              span {{ $$t('form.fields.terms.urls.and') }}
              a.privacy-link(:href="$$s('form.fields.terms.urls.privacy.url')" target="_blank") {{ $$t('form.fields.terms.urls.privacy') }}
          .re-inp-box
            re-checkbox(
              v-model.trim="$v.fields.subscribe.$model"
              v-bind="getFieldProps('subscribe')"
            )
              | Please tick here if you would like us to contact you by email or text with information about goods and services which we feel may be of interest to you. We will process your data in accordance with our 
              a.privacy-link(:href="$$s('form.fields.terms.urls.privacy.url')" target="_blank") {{ $$t('form.fields.terms.urls.privacy') }}
              | . You may withdraw this consent at any time by emailing us.

        .re-submit-button-container(v-show="!hideActions")
          re-button.re-button--primary.re-button--sm.re-submit-button(
            @click="initRegistration" 
            :classes="submitButtonClasses"
            :tabindex="getMaxFieldOrder()"
          ) {{ submitButtonTitle }}

    .re-account-created(v-if="showConfirmation")
      .re-account-created__icon
        img(src="/images/client/got-me-hookd/register-success-icon.svg" alt="")
      .re-account-created__title Success!
      .re-account-created__message Verification link has been sent to your email.

</template>

<script>
import ReRegistration from 'utils/vue/components/complex/user/re-registration/script.js'
import { defaultFormFields, validationsRules } from 'utils/vue/components/complex/user/re-registration/config.js'
import { setValidationRule, truthyRule, required } from 'utils/vue/lib/validations'
import Cookie from 'js-cookie'
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'
import ModalsList from '../../components/modals/modals-list'

validationsRules.username = setValidationRule('fields.username', {
    required: { error: 'Username is required.', rule: required },
})
validationsRules.name = setValidationRule('fields.name', {
    required: { error: 'Display Name is required.', rule: required },
})
validationsRules.gdpr_cookie = setValidationRule('fields.gdpr_cookie', {
    truthy: { error: 'You must accept cookies policy to register and account.', rule: truthyRule },
})

defaultFormFields.username = ''
defaultFormFields.name = ''

export default {
    name: 'gmh-registration',

    mixins: [
        ReRegistration,
    ],

    data() { return {
        showPassword: false,
        fields: {
          username: null,
          name: null,
          gdpr_cookie: null,
          referral_id: null,
        },
    }},

    created() {
        if (this.$route.query.referral) {
            Cookie.set('gmh_referral', this.$route.query.referral)
        }

        this.fields.referral_id = Cookie.get('gmh_referral') || null

        this.setupForm(validationsRules, defaultFormFields)

        this.fields.gdpr_cookie = Cookie.get('gdpr_cookie') || null

        EventBus.$on('cookies-accepted', cookie => {
            this.fields.gdpr_cookie = cookie
        })

        this.$on('error', (e, publicFields) => {
            console.log(e.all)
            if (e.all.gdpr_cookie_used) {
                this.fields.gdpr_cookie = null
                this.formErrorMessage = null
            }
        })

        this.$on('success', () => {
            Cookie.remove('gmh_referral')
        })
    },

    methods: {
        acceptCookies() {
            EventBus.$emit(Events.OPEN_MODAL, ModalsList.ACCEPT_COOKIES)
        },
    },
}
</script>
